import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { StoryBlokService } from '../service/storyblok.service';

@Directive({ selector: '[storyblokRichText]', standalone: true })
export class StoryblokRichTextDirective implements OnChanges {
  @Input() storyblokRichText: any;
  @HostBinding('innerHTML') innerHTML!: SafeHtml;

  constructor(
    private storyblokService: StoryBlokService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this.renderer.addClass(this.el.nativeElement, 'storyblok-rich-text');
    if (changes['storyblokRichText']) {
      try {
        if (this.storyblokRichText) {
          const safeHtml: SafeHtml = this.storyblokService.renderRichText(
            this.storyblokRichText
          );

          this.innerHTML = safeHtml;
        } else {
          this.innerHTML = '';
        }
      } catch {
        this.innerHTML = this.storyblokRichText;
      }
    }
  }
}
